import * as React from 'react';
import { ids, placeholders } from './constants';
import { map, flatten, get } from 'lodash-es';
import { UseFormGetValues } from 'react-hook-form';

interface CheckboxOwnProps {
  fieldName: string;
  labelClass?: string;
  notesName?: string;
  onClick?: (e: any) => void;
  onChange: (e: any) => void;
  onBlur?: (e: any) => void;
  getValues: UseFormGetValues<any>;
}

type CheckboxProps = CheckboxOwnProps;

const Checkbox: React.FC<CheckboxProps> = (props) => {
  const {
    fieldName,
    labelClass,
    notesName,
    onClick,
    onChange,
    onBlur,
    getValues,
  } = props;
  return (
    <label
      className={`checkbox p-y-0 ${labelClass ? labelClass : ''}`}
      id={`${get(ids, fieldName)}_label`}
    >
      <input
        type="checkbox"
        id={get(ids, fieldName)}
        name={fieldName}
        defaultChecked={getValues(fieldName)}
        onChange={onChange}
        onBlur={onBlur}
        onClick={(e: any) => {
          if (onClick) {
            onClick(e);
          }
        }}
      />
      <span className="checkbox-indicator" />
      {notesName ? (
        <span>
          <span className="bold">{get(placeholders(), fieldName)}</span>
          <ul>
            {map(flatten([get(placeholders(), notesName)]), (note, i) => (
              <li key={i}>{note}</li>
            ))}
          </ul>
        </span>
      ) : (
        <span>{get(placeholders(), fieldName)}</span>
      )}
    </label>
  );
};

Checkbox.displayName = 'Checkbox';
export default Checkbox;
